









































import Vue from 'vue'
import moment from 'moment'
import _ from 'lodash'
import XDropdown, { OptionEntry } from '../Dropdown/XDropdown.vue'

const empty = () => undefined
type Optional<T> = T | ReturnType<typeof empty>
type OptionValue = Optional<number>

type Ymd = 'y' | 'm' | 'd'

type Data = {
  y?: number
  m?: number
  d?: number
}

type Props = {
  value?: Date | string
  dateFormat?: string
}

type Methods = {
  options: (type: Ymd) => OptionEntry<OptionValue>[]
  toDate: (y?: number, m?: number, d?: number) => Date | undefined
  onChange: (type: Ymd) => void
  validate: (changed: Ymd) => void
  isRequired: () => boolean
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: 'XBirthdayPicker',
  components: { XDropdown },
  props: {
    value: {
      type: [Date, String],
      required: false,
    },
    dateFormat: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      y: undefined,
      m: undefined,
      d: undefined,
    }
  },
  computed: {
    yearOptions() {
      return this.options('y')
    },
    monthOptions() {
      return this.options('m')
    },
    dayOptions() {
      return this.options('d')
    },
  },
  methods: {
    options(type) {
      const year = moment().year()
      const month = 12
      const day = 31
      const values = {
        y: _.range(year - 100, year + 1),
        m: _.range(1, month + 1),
        d: _.range(1, day + 1),
      }[type]
      const opts = values.map((value) => ({ value, label: String(value) }))
      const emptyOpt = { value: empty(), label: '' }
      return [emptyOpt, ...opts]
    },
    toDate(y?, m?, d?) {
      if (_.some([y, m, d], _.isUndefined)) {
        return undefined
      }
      return moment()
        .year(y as number)
        .month((m as number) - 1)
        .date(d as number)
        .toDate()
    },
    onChange(type) {
      return (v: OptionValue) => {
        this[type] = v ? Number(v) : undefined
        const date = this.toDate(this.y, this.m, this.d)
        this.$emit(
          'input',
          this.dateFormat && date ? moment(date).format(this.dateFormat) : date
        )
        this.validate(type)
      }
    },
    validate(changed) {
      const refs: { [key in Ymd]: HTMLElement } = {
        y: (this.$refs.birthY as Vue).$refs.dropdown as HTMLElement,
        m: (this.$refs.birthM as Vue).$refs.dropdown as HTMLElement,
        d: (this.$refs.birthD as Vue).$refs.dropdown as HTMLElement,
      }
      // 他のインプットのtouchedフラグをオンにする
      const others = (Object.keys(refs) as Ymd[]).filter((v) => v !== changed)
      others.forEach((type) => {
        refs[type].focus()
        refs[type].blur()
      })
      // フォーカスを戻す
      refs[changed].focus()
    },
    isRequired() {
      return !_.every([this.y, this.m, this.d], _.isUndefined)
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        if (newValue) {
          const date = moment(newValue)
          this.y = date.year()
          this.m = date.month() + 1
          this.d = date.date()
        }
      },
    },
  },
})
